module.exports = __webpack_public_path__ + "img/02.eae612ff.png";